import * as types from "../types";

export const getDocument = ({ id }) => ({
  type: types.GET_DOCUMENT,
  request: {
    url: `/documents/${id}`,
    method: "GET"
  }
});

export const createExhibitorDocument = ({ exhibitorId, document }) => ({
  type: types.CREATE_EXHIBITOR_DOCUMENT,
  request: {
    url: `/exhibitors/${exhibitorId}/documents`,
    method: "POST",
    data: {
      document
    }
  },
  meta: {
    mutations: {
      [types.GET_EXHIBITOR]: ({ data }, { data: newDocument }) => {
        return { data: { ...data, documents: [...(data.documents || []), newDocument] } };
      }
    }
  }
});

export const updateDocument = ({ id, document }) => ({
  type: types.UPDATE_DOCUMENT,
  request: {
    url: `/documents/${id}`,
    method: "PATCH",
    data: {
      document
    }
  },
  meta: {
    mutations: {
      [types.GET_EXHIBITOR]: ({ data }, { data: newDocument }) => {
        return {
          data: { ...data, documents: data.documents.map(d => (d.id === id ? newDocument : d)) }
        };
      }
    }
  }
});

export const updateDocumentPdf = ({ documentId, pdf }) => {
  const formData = new FormData();
  formData.append("document[pdf]", pdf);
  return {
    type: types.UPDATE_DOCUMENT_PDF,
    request: {
      url: `/documents/${documentId}/pdf`,
      method: "PATCH",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data: formData
    },
    meta: {
      mutations: {
        [types.GET_DOCUMENT]: ({ data }, { data: newDocument }) => {
          return { data: { ...data, ...newDocument } };
        },
        [types.GET_EXHIBITOR]: ({ data }, { data: newDocument }) => {
          return {
            data: {
              ...data,
              documents: data.documents.map(d => (d.id === documentId ? newDocument : d))
            }
          };
        }
      }
    }
  };
};

export const deleteDocument = ({ id }) => ({
  type: types.DELETE_DOCUMENT,
  request: {
    url: `/documents/${id}`,
    method: "DELETE"
  },
  meta: {
    mutations: {
      [types.GET_EXHIBITOR]: ({ data }) => {
        return { data: { ...data, documents: data.documents.filter(d => d.id !== id) } };
      }
    }
  }
});
